export type SemaphoreProps = {
  enabled: boolean;
  isLoading?: boolean;
  enabledText?: string;
  disabledText?: string;
};

export const Semaphore = ({
  enabled,
  enabledText = ' Enabled',
  disabledText = 'Disabled',
}: SemaphoreProps) => (
  <span style={{ fontSize: '0.8rem' }}>{`${
    enabled ? `🟢 ${enabledText}` : `🛑 ${disabledText}`
  }`}</span>
);
